module.exports = __webpack_public_path__ + "static/media/lol-selector-color.fe9db601.png";